import axios from "axios";

import { getApiUrl } from "@Helpers/api/buildUrl";

export async function logRequiredConsent() {
  const data = undefined;
  const url = getApiUrl("privacy/allow-required");
  const config = { DISABLE_ERROR_INTERCEPTORS: true };

  return axios.get(url, data, config);
}

export async function logAllConsent() {
  const data = undefined;
  const url = getApiUrl("privacy/allow-all");
  const config = { DISABLE_ERROR_INTERCEPTORS: true };

  return axios.get(url, data, config);
}
